import React, { useContext, useEffect, useState } from "react";
import axios from "axios";
import Navbar from "./components/navbar";
import "./Main.scss";
import { Redirect, Route, Switch, useHistory } from "react-router";
import Home from "./components/home";
import {
  getCurrentUserApiCall,
  getFeedRelatedApi,
  loginApiCall
} from "./api/api";
import Account from "./components/account";
import VodDetail from "./components/vodDetail";
import Menu from "./components/menu/Menu";
import Login from "./views/login";
import { MainContext } from "./context/mainContext";
import moment from "moment";
import "moment/locale/tr";
import { Cookies } from "./utils/cookies";

const App = () => {
  const [loading, setLoading] = useState(true);
  const [menuOpened, setMenuOpened] = useState(false);
  const { setIsAuth, setCurrentUser } = useContext(MainContext);
  const history = useHistory();

  const getRelatedFeeds = async () => {
    const { data } = await getFeedRelatedApi();
    data?.items.forEach((item) => {
      if (item?.strategy === "relatedVideos") {
        localStorage.setItem("relatedId", item.id);
      } else if (item?.strategy === "discover") {
        localStorage.setItem("discoverId", item.id);
      }
    });
    setLoading(false);
  };

  const getCurrentUser = async () => {
    const { data } = await getCurrentUserApiCall();
    setCurrentUser(data);
  };

  useEffect(() => {
    moment().locale("tr");

    axios.interceptors.response.use(
      (res) => res,
      (err) => {
        // Do something with request error
        let error = err.toJSON();
        if (error.status === 401 || error.status === 403) {
          setIsAuth(false);
          setLoading(false);
          history.push("/login");
        }
        return Promise.reject(err);
      }
    );

    let token = Cookies.get("token");
    if (token) {
      setIsAuth(true);
      getRelatedFeeds();
      getCurrentUser();
    } else {
      setIsAuth(false);
      setLoading(false);
      history.push("/login");
    }
  }, []);

  return (
    <div>
      {loading ? (
        <h5>Loading...</h5>
      ) : (
        <div>
          <Navbar onClickMenu={() => setMenuOpened(!menuOpened)} />
          <Menu
            menuOpened={menuOpened}
            setMenuOpened={() => setMenuOpened(!menuOpened)}
          />
          <div style={{ marginTop: "70px" }}>
            <Switch>
              <Route path="/home" component={Home} />
              <Route path="/account" component={Account} />
              <Route path="/voddetail/:id" component={VodDetail} />
              <Route path="/login" component={Login} />
              {/* <Redirect path="/home" to="/home/2" /> */}
              <Redirect path="/" to="/home" />
            </Switch>
          </div>
        </div>
      )}
    </div>
  );
};

export default App;
